<template>
  <div class="info_heading">
    <h5>{{ heading }} <span v-if="span">({{ span }})</span></h5>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "InfoHeading",
  props: {
    heading: {
      type: String,
      required: true
    },
    span: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.info_heading {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    font-weight: bold;

    span {
      color: $text-muted;
    }
  }
}

</style>
